module.exports = __webpack_public_path__ + "img/3f_r_cavallo@2x.e810211a.png";